"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleActionScene = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactHotLoader = require("react-hot-loader");

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _Page = require("../../components/Layout/Page");

var _SingleAction = require("../../components/Action/SingleAction");

var _context = require("../../components/ActionModals/ViewAction/context");

const StyledWrap = (0, _styledComponents.default)(_Page.Wrap)`
  max-width: 1280px;
  min-width: 860px;
  height: calc(100vh - ${_blocks.dimension.height.primaryNav});
`;

function mapStateToProps({
  appSetup,
  auth
}) {
  return {
    appSetupComplete: appSetup.appSetupComplete,
    userDisplayName: auth.user.display_name
  };
}

const SingleActionScene = ({
  appSetupComplete,
  userDisplayName,
  match
}) => {
  const [actionId, setActionId] = React.useState(undefined);
  React.useEffect(() => {
    if (appSetupComplete) {
      const actionId = match.params.actionId;
      setActionId(actionId);
    }
  }, [appSetupComplete, match]);
  return /*#__PURE__*/React.createElement(StyledWrap, null, /*#__PURE__*/React.createElement(_reactHelmet.default, {
    title: "View Action"
  }), actionId !== undefined && userDisplayName !== undefined && /*#__PURE__*/React.createElement(_context.ViewActionProvider, null, /*#__PURE__*/React.createElement(_SingleAction.SingleAction, {
    actionId: actionId,
    userDisplayName: userDisplayName
  })));
};

const hotConnected = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps, null)(SingleActionScene));
exports.SingleActionScene = hotConnected;